import { z } from "zod";
import {
  EMAIL_EXISTS,
  INVALID_EMAIL,
  REQUIRED_FIELD,
} from "../../../utils/constants";
import { checkEmailExists } from "../../../helpers/checkEmailExists";

export const UsersItemSchema = z
  .object({
    name: z.string().min(1, { message: REQUIRED_FIELD }),
    email: z
      .string()
      .min(1, { message: REQUIRED_FIELD })
      .email({ message: INVALID_EMAIL }),

    roleOption: z.object({
      id: z.string(),
      name: z.string().min(1, { message: REQUIRED_FIELD }),
      level: z.object({
        id: z.number(),
      }),
    }),

    provinceOption: z
      .object({
        id: z.number(),
        name: z.string(),
      })
      .optional(),

    countyOption: z
      .object({
        id: z.number(),
        name: z.string(),
      })
      .optional(),

    organizationOption: z
      .object({
        id: z.number(),
        name: z.string(),
      })
      .optional(),

    partnerOption: z
      .object({
        id: z.number(),
        name: z.string(),
      })
      .optional(),
    phone: z.string().optional(),
    position: z.string().optional(),
    allowReceiveAlerts: z.boolean().optional(),
    currentEmail: z.string().optional(),
  })
  .refine(
    async (data) => {
      const isValidEmail = z.string().email().safeParse(data.email).success;
      if (!isValidEmail) return true;

      const exists = await checkEmailExists(data.email, data.currentEmail);
      return !exists;
    },
    {
      message: EMAIL_EXISTS,
      path: ["email"],
    },
  )
  .superRefine((data, ctx) => {
    if (data?.roleOption.level.id !== 2 && !data.organizationOption) {
      ctx.addIssue({
        path: ["organizationOption"],
        message: REQUIRED_FIELD,
        code: "custom",
      });
    }

    if (data?.roleOption.level.id === 2 && !data.partnerOption) {
      ctx.addIssue({
        path: ["partnerOption"],
        message: REQUIRED_FIELD,
        code: "custom",
      });
    }

    if (
      data?.roleOption.level.id >= 4 &&
      (!data.provinceOption || !data.provinceOption.id)
    ) {
      ctx.addIssue({
        path: ["provinceOption"],
        message: REQUIRED_FIELD,
        code: "custom",
      });
    }

    if (
      data?.roleOption.level.id === 5 &&
      (!data.countyOption || !data.countyOption.id)
    ) {
      ctx.addIssue({
        path: ["countyOption"],
        message: REQUIRED_FIELD,
        code: "custom",
      });
    }
  });
